import { Navigate, createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/demand/partners/$demandPartnerId/details/')({
  component: DemandPartnerDetailsIndexRoute,
});

function DemandPartnerDetailsIndexRoute() {
  const { demandPartnerId } = Route.useParams();
  return (
    <Navigate
      to="/demand/partners/$demandPartnerId/details/overview"
      params={{ demandPartnerId }}
      replace
    />
  );
}
